var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHunter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2223,
    height: 2223,
    viewBox: "0 0 2223 2223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 2223,
    height: 2223
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1111.5,
    cy: 1111.5,
    r: 1111.5,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2677 1111.5C2677 1976.1 1976.1 2677 1111.5 2677C246.898 2677 -454 1976.1 -454 1111.5C-454 246.898 246.898 -454 1111.5 -454C1976.1 -454 2677 246.898 2677 1111.5Z",
    fill: "#FF5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1271.4 1003.22C1241.58 1011.81 1208.7 1011.95 1177.96 1010.65C1142.2 1009.14 1104.33 1004.61 1071.31 989.928C1044.14 977.85 1022.34 956.055 1033.75 924.575C1041.79 902.373 1059.62 882.539 1080.22 871.36C1103.39 858.783 1128.84 860.827 1152.02 872.193C1178.05 884.957 1199.7 905.718 1219.32 926.665C1229.61 937.65 1239.42 949.056 1249.11 960.571C1253.58 965.869 1283.88 996.152 1271.4 1003.22V1003.22ZM1767.08 1014.05C1721.22 1003.37 1667.03 1007.19 1621.05 999.84C1548.63 988.247 1440.75 903.757 1382.28 817.878C1341.65 758.204 1322.26 697.425 1291.19 623.364C1269.52 571.669 1222.24 408.164 1156.14 484.696C1128.92 516.214 1098.44 619.969 1076.18 618.507C1059.69 622.342 1057 590.19 1051.79 576.449C1042.31 551.498 1037.29 522.631 1024.6 499.102C1014.45 480.297 1001.13 457.77 980.734 448.63C944.39 429.932 900.571 486.287 878.826 553.114C869.528 588.948 807.023 658.41 779.803 675.21C655.951 751.677 407.374 832.238 382.022 1100.5C381.918 1101.61 382.022 1104.99 386.231 1101.94C415.876 1080.47 752.135 838.146 536.334 1306.54C404.128 1593.51 1042.44 1776.25 1075.26 1777C1079.68 1777.09 1079.36 1775.08 1079.51 1773.76C1130.44 1315.74 1633.65 1363.96 1750.83 1254.26C1866.97 1145.57 1869.33 1040.36 1767.08 1014.05",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHunter);
export default __webpack_public_path__ + "static/media/hunter.c7a4dc9cc800e0c58e96dc555db25d9e.svg";
export { ForwardRef as ReactComponent };